import { render, staticRenderFns } from "./tabFurnitureReports.vue?vue&type=template&id=0988da9a&"
import script from "./tabFurnitureReports.vue?vue&type=script&lang=js&"
export * from "./tabFurnitureReports.vue?vue&type=script&lang=js&"
import style0 from "./tabFurnitureReports.vue?vue&type=style&index=0&id=0988da9a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports